import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {HomeService} from '../../_services/home.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  data:any;
  constructor(private homeService:HomeService, private title:Title) { }
  showDeep:boolean=false;
  ngOnInit(): void {
      this.title.setTitle('Play Online Delhi: Satta King | Delhi Satta | Satta Bazar | POD');
      this.getToday();
      var today = new Date();
      var forDate = new Date('2023-11-15');
      if(today.getTime() <= forDate.getTime())
      {
        this.showDeep = true;
      }
  }

  getToday(){
    this.homeService.getToday().subscribe((data) => {
        console.log(data);
        this.data = data;
    })
  }

}
